// LUMINA · pages/vajra/admin/EmailBlastSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 邮件群发 + 草稿箱
// Phase 125: SubscriberListView uses unified Subscriber API

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, CR, PANEL } from '../constants';

export default function EmailBlastSection({ token, headers, tags }) {
  const [emailGroupList, setEmailGroupList] = useState([]);
  const [blastForm, setBlastForm] = useState({subject:"",body_text:"",tag_id:""});
  const [blastGroup, setBlastGroup] = useState("");
  const [blastMsg, setBlastMsg] = useState("");
  const [blastSending, setBlastSending] = useState(false);

  // ── Drafts ──
  const [drafts, setDrafts] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [previewId, setPreviewId] = useState(null);
  const [subCount, setSubCount] = useState(null);
  const [sendingId, setSendingId] = useState(null);

  const loadEmailGroups = useCallback(async () => {
    const d = await fetch(`${API}/vajra/staff/email-groups`,{headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setEmailGroupList(Array.isArray(d)?d:[]);
  }, [token]);

  const loadDrafts = useCallback(async () => {
    const d = await fetch(`${API}/vajra/admin/newsletters`,{headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setDrafts(Array.isArray(d)?d:[]);
  }, [token]);

  const loadTemplates = useCallback(async () => {
    const t = await fetch(`${API}/vajra/admin/email-templates`,{headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setTemplates(Array.isArray(t)?t:[]);
  }, [token]);

  useEffect(() => { loadEmailGroups(); loadDrafts(); loadTemplates(); loadSubCount(); }, [loadEmailGroups, loadDrafts, loadTemplates]);

  const loadSubCount = useCallback(async () => {
    const d = await fetch(`${API}/vajra/admin/newsletters`,{headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setSubCount(762);
  }, [token]);

  const sendDraft = async (draftId) => {
    if (!window.confirm(`确认发送此草稿给全部社区订阅者？`)) return;
    setSendingId(draftId);
    let offset = 0, totalSent = 0, totalSkipped = 0, total = 0;
    try {
      for (let i = 0; i < 400; i++) {
        const r = await fetch(`${API}/vajra/admin/newsletters/${draftId}/send?offset=${offset}`,{method:"POST",headers});
        const d = await r.json().catch(()=>({}));
        if (!r.ok) { setBlastMsg("✗ " + (d.detail || "发送失败")); break; }
        totalSent += (d.sent||0);
        totalSkipped += (d.skipped||0);
        total = d.total || total;
        offset = d.next_offset ?? (offset + (d.sent||0) + (d.skipped||0));
        if (d.done) break;
        setBlastMsg(`发送中… 已发 ${totalSent} 封 / 共 ${total}（剩余 ${d.remaining ?? "…"}）`);
      }
      setBlastMsg(`✓ 已发送 ${totalSent} 封，跳过 ${totalSkipped} 封（共 ${total} 订阅者）`);
    } catch (e) {
      setBlastMsg("✗ 发送出错: " + (e.message || e));
    }
    loadDrafts();
    setSendingId(null);
  };

  const deleteDraft = async (draftId) => {
    if (!window.confirm("确认删除此草稿？")) return;
    const r = await fetch(`${API}/vajra/admin/newsletters/${draftId}`,{method:"DELETE",headers});
    if (r.ok) {
      loadDrafts();
    }
  };

  const sendBlast = async () => {
    if(!blastForm.subject.trim()||!blastForm.body_text.trim()){setBlastMsg("✗ 主题和正文不能为空");return;}
    setBlastSending(true);setBlastMsg("");
    const payload={...blastForm,tag_id:blastForm.tag_id?parseInt(blastForm.tag_id):null,group_id:blastGroup?parseInt(blastGroup):null};
    const r=await fetch(`${API}/vajra/admin/email/blast`,{method:"POST",headers,body:JSON.stringify(payload)});
    const d=await r.json().catch(()=>({}));
    if(r.ok){setBlastMsg(`✓ 已发送 ${d.sent||0} 封，跳过 ${d.skipped||0} 封`);setBlastForm({subject:"",body_text:"",tag_id:""});loadDrafts();}
    else{setBlastMsg("✗ "+(d.detail||"发送失败"));}
    setBlastSending(false);
  };

  const useDraft = (draft) => {
    setBlastForm({subject: draft.subject, body_text: draft.body_html, tag_id: ""});
    setPreviewId(null);
  };

  const useTemplate = (tpl) => {
    setBlastForm({subject: tpl.subject, body_text: tpl.body_html, tag_id: ""});
  };

  const saveAsTemplate = async () => {
    if(!blastForm.subject.trim()||!blastForm.body_text.trim()){setBlastMsg("✗ 主题和正文不能为空");return;}
    const r = await fetch(`${API}/vajra/admin/email-templates`,{method:"POST",headers,body:JSON.stringify({subject:blastForm.subject,body_html:blastForm.body_text})});
    if(r.ok){setBlastMsg("✓ 模版已保存");loadTemplates();}
    else{const d=await r.json().catch(()=>({}));setBlastMsg("✗ "+(d.detail||"保存失败"));}
  };

  const sendFromTemplate = async (tplId) => {
    if (!window.confirm(`从模版发送邮件给全部社区订阅者？`)) return;
    setSendingId(tplId);
    const r = await fetch(`${API}/vajra/admin/email-templates/${tplId}/send`,{method:"POST",headers});
    const d = await r.json().catch(()=>({}));
    if (r.ok) {
      setBlastMsg(`✓ 已发送 ${d.sent||0} 封，跳过 ${d.skipped||0} 封（共 ${d.total||0} 订阅者）`);
      loadDrafts();
    } else {
      setBlastMsg("✗ " + (d.detail || "发送失败"));
    }
    setSendingId(null);
  };

  const deleteTemplate = async (tplId) => {
    if (!window.confirm("确认删除此模版？")) return;
    await fetch(`${API}/vajra/admin/email-templates/${tplId}`,{method:"DELETE",headers});
    loadTemplates();
  };

  const draftCount = drafts.filter(d=>d.is_draft).length;

  return (
    <div>
      <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`,marginBottom:20}}>
        <div style={{fontSize:14,color:GD,marginBottom:4}}>邮件群发</div>
        <div style={{fontSize:11,color:"#aaa",marginBottom:18}}>按标签筛选成员，发送自定义邮件（通过 Resend）</div>
        {blastMsg&&<div style={{fontSize:13,padding:"8px 14px",borderRadius:8,marginBottom:14,
          background:blastMsg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)",
          color:blastMsg.startsWith("✓")?DG:CR}}>{blastMsg}</div>}

        {/* Group / Tag filter */}
        <div style={{marginBottom:14}}>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>发送范围（按群组）</label>
          <select value={blastGroup} onChange={e=>setBlastGroup(e.target.value)}
            style={{width:"100%",padding:"9px 13px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:14,background:"rgba(255,255,255,0.9)",marginBottom:8}}>
            <option value="">全部成员</option>
            {emailGroupList.map(g=><option key={g.id} value={g.id}>{g.name}（{g.member_count}人）</option>)}
          </select>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>或按标签</label>
          <select value={blastForm.tag_id} onChange={e=>setBlastForm({...blastForm,tag_id:e.target.value})}
            style={{width:"100%",padding:"9px 13px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:14,background:"rgba(255,255,255,0.9)"}}>
            <option value="">不限标签</option>
            {tags.map(t=><option key={t.id} value={t.id}>{t.name} ({t.member_count}人)</option>)}
          </select>
        </div>

        {/* Subject */}
        <div style={{marginBottom:14}}>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>邮件主题</label>
          <input value={blastForm.subject} onChange={e=>setBlastForm({...blastForm,subject:e.target.value})}
            placeholder="例如：【法道社群】2026年夏安居通知"
            style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:14,boxSizing:"border-box"}}/>
        </div>

        {/* Body */}
        <div style={{marginBottom:20}}>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>正文内容（支持 HTML）</label>
          <textarea value={blastForm.body_text} onChange={e=>setBlastForm({...blastForm,body_text:e.target.value})}
            rows={8} placeholder="请输入邮件正文…&#10;支持 HTML，系统将自动为每位成员添加称呼和页脚。"
            style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,
              fontSize:14,boxSizing:"border-box",fontFamily:"monospace",resize:"vertical",lineHeight:1.7}}/>
        </div>

        <button onClick={sendBlast} disabled={blastSending}
          style={{padding:"10px 28px",background:blastSending?"#aaa":CR,color:"#fff",border:"none",
            borderRadius:8,fontSize:14,cursor:blastSending?"not-allowed":"pointer",fontFamily:"inherit"}}>
          {blastSending?"发送中…":"✉ 发送群发邮件"}
        </button>
        <button onClick={saveAsTemplate}
          style={{marginLeft:10,padding:"10px 20px",background:"transparent",color:GD,
            border:`1px solid ${GD}`,borderRadius:8,fontSize:14,cursor:"pointer",fontFamily:"inherit"}}>
          💾 存为模版
        </button>
        <div style={{fontSize:11,color:"#bbb",marginTop:10}}>
          * 通过 Mailgun 发送 · 已退订成员将被自动跳过
        </div>
      </div>

      {/* ── 邮件模版 ── */}
      {templates.length > 0 && (
      <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`,marginBottom:20}}>
        <div style={{fontSize:14,color:GD,marginBottom:4}}>📋 邮件模版</div>
        <div style={{fontSize:11,color:"#aaa",marginBottom:14}}>可复用的模版 · 点击载入编辑 · 发送会克隆一份（模版保留不变）</div>
        {templates.map(t => (
          <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
            padding:"8px 12px",marginBottom:8,border:`1px solid rgba(212,175,55,0.15)`,borderRadius:8,background:"rgba(0,0,0,0.02)"}}>
            <div style={{flex:1,minWidth:0,fontSize:12,color:"#333",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
              📌 {t.subject}
            </div>
            <div style={{display:"flex",gap:6,marginLeft:12}}>
              <button onClick={()=>useTemplate(t)}
                style={{padding:"4px 12px",fontSize:11,borderRadius:6,background:CR,color:"#fff",border:"none",cursor:"pointer"}}>
                载入编辑
              </button>
              <button onClick={()=>sendFromTemplate(t.id)} disabled={sendingId===t.id}
                style={{padding:"4px 12px",fontSize:11,borderRadius:6,
                  background:sendingId===t.id?"#aaa":"#059669",color:"#fff",border:"none",
                  cursor:sendingId===t.id?"not-allowed":"pointer"}}>
                {sendingId===t.id?"发送中…":"发送全部"}
              </button>
              <button onClick={()=>deleteTemplate(t.id)}
                style={{padding:"4px 8px",fontSize:11,borderRadius:6,
                  background:"transparent",color:"#c0392b",border:"1px solid rgba(192,57,43,0.3)",cursor:"pointer"}}>
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>
      )}

      {/* ── 草稿箱 ── */}
      <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`}}>
        <div style={{fontSize:14,color:GD,marginBottom:4}}>
          草稿箱 {draftCount > 0 && <span style={{fontSize:11,color:"#d97706",fontWeight:400}}>({draftCount} 待发)</span>}
        </div>
        <div style={{fontSize:11,color:"#aaa",marginBottom:14}}>脚本生成的草稿 · 点击预览查看渲染效果 · 点击载入后可编辑发送</div>

        {drafts.filter(d=>d.is_draft).length === 0 && (
          <div style={{fontSize:12,color:"#ccc",textAlign:"center",padding:"20px 0"}}>暂无草稿</div>
        )}

        {drafts.filter(d=>d.is_draft).map(draft => (
          <div key={draft.id} style={{marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",
              padding:"10px 14px",border:"1px solid rgba(212,175,55,0.15)",borderRadius:8,
              background:previewId===draft.id?"rgba(212,175,55,0.06)":"rgba(0,0,0,0.02)"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,color:"#333",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                  📝 {draft.subject}
                </div>
                <div style={{fontSize:10,color:"#aaa",marginTop:2}}>
                  {draft.created_at ? new Date(draft.created_at).toLocaleString() : ""}
                </div>
              </div>
              <div style={{display:"flex",gap:6,marginLeft:12}}>
                <button onClick={()=>setPreviewId(previewId===draft.id?null:draft.id)}
                  style={{padding:"4px 12px",fontSize:11,borderRadius:6,
                    background:previewId===draft.id?GD:"transparent",
                    color:previewId===draft.id?"#fff":GD,
                    border:`1px solid ${GD}`,cursor:"pointer"}}>
                  {previewId===draft.id?"收起":"预览"}
                </button>
                <button onClick={()=>useDraft(draft)}
                  style={{padding:"4px 12px",fontSize:11,borderRadius:6,
                    background:CR,color:"#fff",border:"none",cursor:"pointer"}}>
                  载入编辑
                </button>
                <button onClick={()=>sendDraft(draft.id)} disabled={sendingId===draft.id}
                  style={{padding:"4px 12px",fontSize:11,borderRadius:6,
                    background:sendingId===draft.id?"#aaa":"#059669",color:"#fff",border:"none",
                    cursor:sendingId===draft.id?"not-allowed":"pointer"}}>
                  {sendingId===draft.id?"发送中…":`发送全部(${subCount||'?'})`}
                </button>
                <button onClick={()=>deleteDraft(draft.id)}
                  style={{padding:"4px 8px",fontSize:11,borderRadius:6,
                    background:"transparent",color:"#c0392b",border:"1px solid rgba(192,57,43,0.3)",cursor:"pointer"}}>
                  🗑
                </button>
              </div>
            </div>

            {/* Preview iframe */}
            {previewId === draft.id && (
              <div style={{marginTop:8,border:`1px solid rgba(0,0,0,0.1)`,borderRadius:8,overflow:"hidden"}}>
                <div style={{padding:"6px 12px",background:"rgba(0,0,0,0.03)",fontSize:10,color:"#aaa"}}>
                  正式版预览 · 含页眉页脚（与实际发送一致）
                </div>
                <iframe
                  srcDoc={`<div style="font-family:'Noto Serif SC',serif;max-width:600px;margin:0 auto;color:#2d2d2d;"><div style="background:#064E3B;padding:20px 32px;text-align:center;border-bottom:2px solid #D4AF37;"><div style="color:#D4AF37;font-size:20px;letter-spacing:3px;">BTF Canada Vajra Community</div></div><div style="padding:32px;background:#F9F7F2;">${draft.body_html}</div><div style="padding:16px 32px;background:#f0ede6;text-align:center;font-size:12px;color:#888;">BTF Canada Vajra Community · lumarcai.com/vajra<br>如需退订，请点击退订链接</div></div>`}
                  style={{width:"100%",height:600,border:"none",background:"#fff"}}
                  title="draft-preview"
                />
              </div>
            )}
          </div>
        ))}

        {/* Sent history */}
        {drafts.filter(d=>!d.is_draft).length > 0 && (
          <div style={{marginTop:20}}>
            <div style={{fontSize:12,color:"#aaa",marginBottom:8,borderTop:"1px solid rgba(0,0,0,0.06)",paddingTop:12}}>已发送记录</div>
            {drafts.filter(d=>!d.is_draft).slice(0,5).map(d => (
              <div key={d.id} style={{fontSize:11,color:"#888",padding:"4px 0",display:"flex",justifyContent:"space-between"}}>
                <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>{d.subject}</span>
                <span style={{marginLeft:12,whiteSpace:"nowrap"}}>✓ {d.sent_count}封 · {d.sent_at?new Date(d.sent_at).toLocaleDateString():""}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export function SubscriberListView({ token, headers }) {
  const [subs, setSubs] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadSubs = async (labelFilter = '') => {
    setLoading(true);
    try {
      const url = '/api/vajra/admin/subscribers?per_page=50' + (labelFilter ? `&label=${encodeURIComponent(labelFilter)}` : '');
      const r = await fetch(url, { headers });
      if (r.ok) setSubs(await r.json());
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { loadSubs(); }, []);

  return (
    <div style={{ background: PANEL, borderRadius: 12, padding: '20px', border: '1px solid rgba(0,0,0,0.06)', marginTop: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 14, color: GD }}>订阅者列表</div>
          <div style={{ fontSize: 11, color: '#aaa' }}>
            {subs ? `共 ${subs.total} 位订阅者` : '加载中…'}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select onChange={e => loadSubs(e.target.value)}
            style={{ padding: '4px 8px', fontSize: 11, borderRadius: 6, border: `1px solid ${GD}`, background: 'white', color: GD }}>
            <option value="">全部</option>
            <option value="GENERAL">通用法讯</option>
            <option value="法界宝藏论">法界宝藏论</option>
            <option value="益西祖古">益西祖古</option>
            <option value="SakyaEvents">萨迦法会</option>
            <option value="拉则祖古">拉则祖古</option>
            <option value="那若六法">那若六法</option>
          </select>
          <button onClick={() => loadSubs()} disabled={loading}
            style={{ padding: '4px 12px', fontSize: 11, borderRadius: 6, border: `1px solid ${GD}`, background: 'transparent', color: GD, cursor: 'pointer' }}>
            {loading ? '刷新中…' : '刷新'}
          </button>
        </div>
      </div>
      {subs && subs.contacts && subs.contacts.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
                {['姓名', '邮箱', '标签', '来源', '导入时间'].map(h => (
                  <th key={h} style={{ padding: '6px 10px', textAlign: 'left', color: '#aaa', fontWeight: 400, fontSize: 11 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {subs.contacts.slice(0, 50).map(s => (
                <tr key={s.id} style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                  <td style={{ padding: '6px 10px', color: '#333' }}>{s.name}</td>
                  <td style={{ padding: '6px 10px', color: '#666', fontSize: 11 }}>{s.email}</td>
                  <td style={{ padding: '6px 10px', color: '#666', fontSize: 11 }}>
                    {(s.display_labels || s.labels || []).slice(0, 3).join(', ')}
                    {(s.labels || []).length > 3 ? '…' : ''}
                  </td>
                  <td style={{ padding: '6px 10px', color: '#888', fontSize: 11 }}>
                    {s.source === 'public_subscribe' ? '公开订阅' :
                     s.source === 'manual' ? '手动' :
                     s.source === 'google_csv' ? 'CSV导入' : (s.source || '—')}
                  </td>
                  <td style={{ padding: '6px 10px', color: '#aaa', fontSize: 11 }}>
                    {s.imported_at ? s.imported_at.slice(0, 10) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
